<template>
  <Modal
    :id="'cmp-settings-users-add_permission-external-user_form'"
    @cancelled="onCancel"
  >
    <template slot="header">{{$t('add_new_permissions_for_royalty')}}</template>

    <template slot="body">
      <div class="item-search">
        <InputField
          :value="searchString"
          :placeholder="$t('search')"
          :config="{
            borderStyle: 'around',
            maxWidth: '200px',
            minWidth: '200px',
            width: '200px',
          }"
          @keyup="onSearchInputkeyup"
        ></InputField>
        <Dropdown
          :id="'invoice_project_id'"
          :options="invoice_projectsTV"
          class="m2"
          :selected="
            invoice_projectsTV.find((b) => b.value == invoice_project_id)
          "
          :placeholder="$t('royalty_project')"
          box
          @selectedChange="(b) => onDropdownChange('invoice_project_id', b)"
          style="width: 250px"
          :listHeight="200"
          deselect
          :showValidationIcons="false"
        ></Dropdown>
      </div>
      <div class="item-container">
        <table class="dt-table2 search-list">
          <tbody class="dt-table2--body">
            <tr
              class="dt-table2--row"
              v-for="royalty_account of royalty_accounts"
              :key="royalty_account['royalty_account_id']"
              @click="(e) => onSelected(royalty_account)"
            >
              <td style="max-width: 30px" class="dt-table2--column">
                <div class="dt-checkbox v2 s1">
                  <input
                    type="checkbox"
                    :name="royalty_account.royalty_account_id"
                    :id="royalty_account.royalty_account_id"
                    :checked="
                      selected_royalties.has(royalty_account.royalty_account_id)
                    "
                    @click.stop="
                      (e) =>
                        onCheckboxChange(
                          e,
                          'royalty_account_id',
                          royalty_account
                        )
                    "
                  />
                  <div class="checkmark"></div>
                </div>
              </td>
              <td class="dt-table2--column">
                {{ royalty_account.item_name }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <span style="color: red">
        {{$t('by_clicking_on_save_you_confirm')}}
      </span>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{$t('cancel')}}
      </button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">
        {{$t('ok')}}
      </button>
    </template>
  </Modal>
</template>
  
  <script>
import Modal from "@dtplugins/modal/modal";
import { Subject } from "rxjs";
import InputField from "../../../../plugins/text-field/input-field";
import { subscribeSubject } from "../../../../utility";
import { UserService } from "../../services/user.service";
import SearchList from "@dtplugins/search-list/search-list";
import { addRemoveSet } from "../../../../utility";
import { createTV } from "../../../../models/text-value.model";
export default {
  props: ["selectedAccountDetails"],
  components: {
    Modal,
    InputField,
    SearchList,
  },

  data: function () {
    return {
      royalty_accounts: [],
      royalty_projects: [],
      searchString: null,
      searchSubject$: new Subject(),
      searchSize: "single",
      selected_royalties: new Set(),
      invoice_project_id: 0,
    };
  },
  mounted: function () {
    UserService.openRoyaltyStatementPermissionModal({
      external_user_id: this.user_id,
    }).then((res) => {
      this.royalty_accounts = res.data.royalty_accounts;
      this.royalty_projects = res.data.royalty_projects;
    });
    subscribeSubject(this, this.searchSubject$, (searchString) => {
      UserService.searchRoyaltyAccountOfExt_user({
        external_user_id: this.external_user_id,
        search_txt: this.searchString,
        invoice_project_id: this.invoice_project_id,
      }).then((res) => {
        this.royalty_accounts = res.data.royalty_accounts;
      });
    });
  },
  computed: {
    external_user_id: function () {
      return this.$route.params.external_user_id;
    },
    invoice_projectsTV: function () {
      return createTV(
        this.royalty_projects || [],
        "invoice_project_name",
        "invoice_project_id"
      );
    },
    searchStringLength: function () {
      if (this.searchString.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    hRowMarginRight: function () {
      if (this.unrelated_users.length > 380 / 28) {
        return "28px";
      }
    },
  },
  methods: {
    addChecklist: function (e) {},
    onCancel: function (e) {},
    onSearchInputkeyup: function (e) {
      this.searchString = e.target.value;
      this.searchSubject$.next(this.searchString);
    },
    onDropdownChange: function (name, value) {
      this.invoice_project_id = value.value;
      UserService.searchRoyaltyAccountOfExt_user({
        external_user_id: this.external_user_id,
        search_txt: this.searchString,
        invoice_project_id: this.invoice_project_id,
      }).then((res) => {
        this.royalty_accounts = res.data.royalty_accounts;
      });
    },
    searchExternalUserPermission: function (searchString) {
      this.searchString = searchString;
      UserService.searchRoyaltyAccountOfExt_user({
        external_user_id: this.external_user_id,
        search_txt: this.searchString,
        invoice_project_id: this.invoice_project_id,
      }).then((res) => {
        this.royalty_accounts = res.data.royalty_accounts;
      });
    },
    onCheckboxChange: function (event, name, item) {
      const value = event.target.checked;
      this.selected_royalties = addRemoveSet(
        event.target.checked,
        this.selected_royalties,
        item.royalty_account_id
      );

      console.log("WWWW", item.royalty_account_id, value);
    },

    onSelected: function (item) {
      this.selected_royalties = addRemoveSet(
        'toggle',
        this.selected_royalties,
        item.royalty_account_id
      );
    },
    async onOkClick() {
      const external_ids = Array.from(this.selected_royalties).join(",");
      const res = await UserService.addExternalUserPermission({
        external_user_id: this.external_user_id,
        external_ids: external_ids,
      });
      if (res.data) {
        const res = await UserService.loadRoyaltyStatementPermissions({
          external_user_id: this.external_user_id,
        });

        this.$emit("added", res.data.royalty_accounts);
      }
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onAddClick: function () {
      this.$emit("add_click", "new_access_form");
    },
  },
};
</script>
  
  <style lang="scss" >
.cmp-settings-users-add_permission-external-user_form {
  .dt-table2 {
    --body-height: 250px;
  }
  .item-container {
    padding-bottom: 20px;
  }
  .dropdown .dropdown--main .dropdown--main__label.expanded {
    top: 5px !important;
  }
  .dropdown.box {
    min-height: 32px !important;
    padding: 0;
    height: 32px;
  }
  .item-search {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 15px;
  }
  .dt-table2.search-list {
    --row-margin: 0px 4px;
  }
  .ut-flex {
    .checkbox-container {
      flex: 0.1 !important;
    }

    .txtov {
      flex: 0.9 !important;
    }
  }
}
</style>
  